/**
 * 资产API配置
 * {
 *   name: 调用接口的别名
 *   url：api
 *   method：get | post | put | delete
 * }
 */
export default {
  // 资产列表
  getAssetsList: {
    name: "getAssetsList",
    url: "/ams/asset/orderList",
    method: "get"
  },
  // 资产详情
  getAssetsDetail: {
    name: "getAssetsDetail",
    url: "/ams/asset/orderDetail",
    method: "get"
  },
  // 获取验证码
  getVerifyCode: {
    name: "getVerifyCode",
    url: "/ams/sms/createSms",
    method: "get"
  },
  // 提交意向
  sendIntention: {
    name: "sendIntention",
    url: "/ams/asset/inclineOrder",
    method: "post"
  },
  // 获取地区下拉框数据
  getCascadeAddress: {
    name: "getCascadeAddress",
    url: "/ams/utils/cascadeAddress",
    method: "get"
  },
  // 获取担保物类别
  getCascadeCollateralType: {
    name: "getCascadeCollateralType",
    url: "/ams/amsEnums/cascadecCollateralType",
    method: "get"
  }
};
